import { im_proto } from '../proto/index.js';
import { Logger } from './metrics/logger.js';
import { IMEvent, TriggerType } from './consts.js';

const defaultOption = {
    // 一定会被 assign 覆盖
    appId: 0,
    token: '',
    deviceId: '',
    userId: '',
    biz: '',
    apiUrl: '',
    frontierUrl: '',
    fpId: 89,
    appKey: 'e0f82475ab9dbf5717d18b4a9c0d7fd0',
    service: 2,
    method: 1,
    authType: im_proto.AuthType.TOKEN_AUTH,
    inboxType: [0],
    headers: {},
    httpHeaders: {},
    devicePlatform: 'web',
    timeout: 2000,
    pullInterval: 30000,
    throttle: 100,
    triggerStrategy: {
        [IMEvent.ConversationChange]: TriggerType.Debounce,
        [IMEvent.MessageUpsert]: TriggerType.Debounce,
        [IMEvent.ConversationUpsert]: TriggerType.ThrottleWithArgs
    },
    maxMessageCount: 1000
};
function checkMapTypes(ctx, name, map) {
    for (const key of Object.keys(map)) {
        if (typeof map[key] !== 'string') {
            Logger.ctxError(ctx, `${name}[${key}] is not a string!`);
        }
    }
}
// 检查必要参数
function optionCheck(ctx, opt) {
    if (typeof opt.appId !== 'number') {
        Logger.ctxError(ctx, 'opt.appId is not a number! did you pass a string?');
    }
    if (typeof opt.deviceId !== 'string') {
        Logger.ctxError(ctx, 'opt.deviceId is not a string! did you pass a number?');
    }
    if (typeof opt.userId !== 'string') {
        Logger.ctxError(ctx, 'opt.userId is not a string! did you pass a number?');
    }
    if (typeof opt.apiUrl !== 'string' || opt.apiUrl.length === 0) {
        Logger.ctxError(ctx, 'opt.apiUrl invalid');
    }
    if (typeof opt.frontierUrl !== 'string' || opt.frontierUrl.length === 0) {
        Logger.ctxError(ctx, 'opt.frontierUrl invalid');
    }
    if (typeof opt.headers === 'object') {
        checkMapTypes(ctx, 'opt.headers', opt.headers);
    }
    if (typeof opt.httpHeaders === 'object') {
        checkMapTypes(ctx, 'opt.httpHeaders', opt.httpHeaders);
    }
    if (typeof opt.monitorTagKv === 'object') {
        checkMapTypes(ctx, 'opt.monitorTagKv', opt.monitorTagKv);
    }
    // inbox array is empty or contains negative inbox
    if ((Array.isArray(opt.inboxType) && (opt.inboxType.length === 0 || opt.inboxType.some(i => i < 0))) ||
        (typeof opt.inboxType === 'number' && opt.inboxType < 0)) {
        Logger.ctxError(ctx, 'opt.inboxType invalid');
    }
    if (typeof opt.pullInterval === 'number' && opt.pullInterval < 5000) {
        Logger.ctxDebug(ctx, 'opt.pullInterval too short');
    }
}
function applyDefault(userOpt) {
    return Object.assign(Object.assign(Object.assign({}, defaultOption), userOpt), { triggerStrategy: Object.assign(Object.assign({}, defaultOption.triggerStrategy), userOpt.triggerStrategy) });
}
function applyDefaultBoe(userOpt) {
    return Object.assign(Object.assign(Object.assign({ debug: true, boe: true }, defaultOption), userOpt), { triggerStrategy: Object.assign(Object.assign({}, defaultOption.triggerStrategy), userOpt.triggerStrategy) });
}

export { applyDefault, applyDefaultBoe, optionCheck };
//# sourceMappingURL=options.js.map
